import { render, staticRenderFns } from "./DraggableFields.vue?vue&type=template&id=50fdac60&scoped=true"
import script from "./DraggableFields.vue?vue&type=script&lang=js"
export * from "./DraggableFields.vue?vue&type=script&lang=js"
import style0 from "./DraggableFields.vue?vue&type=style&index=0&id=50fdac60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fdac60",
  null
  
)

export default component.exports